<template>
    <vs-popup class="add-new-incoterms" id="popup" title="CHECK COMPANY NAME" @close="open = false" :active.sync="open"
        :buttons-hidden="true">
        <vx-card no-shadow>
            <div class="mb-3 vx-row">
                <div class="w-full vx-col md:w-1/2 md:mb-0"> <small class="label">Company Name</small>
                    <vs-input v-model="company_name" name="company_name" class="w-full" label="" @input="onInputCompanyName"
                        val-icon-pack="feather" />
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-1/3 mb-4" v-for="(lead, index) in existing_company_list" :key="index">
                    <span class="text-primary font-bold cursor-pointer" @click.stop="onClickOpenLead(lead)">
                        {{ lead.company_name || 'N/A' }} ( {{ lead.code || lead.account_number }} )
                    </span>
                </div>
            </div>
            <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button button="submit" class="ml-auto mt-2" @click.stop="onClickUse">Use this name</vs-button>
            </div>
        </vx-card>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        company_name: '',
        existing_company_list: [],
    }
}

export default {
    name: 'CheckLeadCompanyNamePopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup() {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true;
            } catch (error) {

            }
        },
        async onInputCompanyName() {
            await this.searchComapnyName(this)
        },
        searchComapnyName: _.debounce(async (vm) => {
            const { data } = (await CrmRepository.checkCompanyNameExisits(vm.company_name)).data
            vm.existing_company_list = data
            // vm.existing_company_list = data.filter((x) => {
            //     const companyName = x.company_name ? x.company_name.toLowerCase() : null;
            //     const formCompanyName = vm.form.company_name ? vm.form.company_name.toLowerCase() : null;
            //     return companyName === formCompanyName && !!companyName;
            // }).map((x) => x.company_name)
        }, 350),
        onClickUse() {
            this.$emit('useCompanyName', this.company_name)
            this.open = false
        },
        onClickOpenLead(lead) {
            // const statusMap = {
            //     'Pending': '',
            //     'Junk': '',
            //     'Lead': '-suspect',
            //     'Opportunity': '-opportunities',
            //     'Subscriber': '-influence',
            //     'Closed NIO': '-closed',
            // };
            // const status = lead.status in statusMap ? statusMap[lead.status] : '';
            // const route = this.$router.resolve({ path: `/pages/crm/marketing-leads${status}/${lead.id}` });
            // window.open(route.href, '_blank');
            let path = ''
            if(lead.type === 'Customer') {
                path = `/pages/manage-nimble/customers/${lead.id}`
            } else {
                path = `/pages/crm/marketing-leads-suspect/${lead.id}`
            }
            const route = this.$router.resolve({ path: path });
            window.open(route.href, '_blank');
        }
    },
    components: {
        'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    /* min-height: 30% !important; */
    min-width: 60% !important;
}
</style>
  